import script from "./GeovisUI.vue?vue&type=script&setup=true&lang=js"
export * from "./GeovisUI.vue?vue&type=script&setup=true&lang=js"

import "./GeovisUI.vue?vue&type=style&index=0&id=4702d6b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4702d6b8"]])

export default __exports__